<template>
  <div class="cmp-third-party-info">
    <!-- eslint-disable-next-line vue/no-v-html -->
    <p v-html="xss($t('third_party.dialog.info'))"></p>
    <ul>
      <!-- eslint-disable vue/no-v-html -->
      <li
        v-for="label in selectedLinks"
        :key="label"
        v-html="xss($t(`third_party.dialog.terms.${label}`))"
      ></li>
      <!-- eslint-enable vue/no-v-html -->
    </ul>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import config from '@/services/config.service';
import xss from 'xss';

@Component({})
export class ThirdPartyInfo extends Vue {
  xss = xss;
  get selectedLinks() {
    switch (config.companyCountry) {
    case 'SE':
      return ['se', 'nu', 'eu', 'pl', 'uk', 'icann'];
    case 'SK':
      return ['sk', 'cz', 'hu', 'at', 'eu', 'rest', 'ssl'];
    case 'CZ':
      return ['cz', 'sk', 'hu', 'at', 'eu', 'rest', 'ssl'];
    case 'HU':
      return ['cz', 'sk', 'hu', 'at', 'eu', 'rest', 'ssl'];
    default:
      return [
        'se',
        'nu',
        'eu',
        'uk',
        'pl',
        'sk',
        'cz',
        'hu',
        'at',
        'eu',
        'rest',
        'ssl',
      ];
    }
  }
}

export default ThirdPartyInfo;
</script>

<style lang="scss" scoped>
.cmp-third-party-info {
  min-width: 480px;
  max-width: 700px;
  min-height: 160px;
  padding: 24px 32px;

  ul {
    margin-bottom: 0;
    padding-left: 16px;

    li {
      list-style-type: disc;
    }
  }
}
</style>
